import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import i1 from "./assets/images/TeruGifNew.gif";

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: #ffffff;
  padding: 10px;
  font-weight: bold;
  color: #000000;
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledInput = styled.input`
  padding: 10px;
  border-radius: 50px;
  border: none;
  text-align: center;
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledImg = styled.img`
  width: 200px;
  height: 200px;
  @media (min-width: 767px) {
    width: 350px;
    height: 350px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState("Maybe it's your lucky day.");
  const [claimingNft, setClaimingNft] = useState(false);
  const [input, setInput] = useState(1); // '' is the initial state value
  const price = 3
  const gasLimit = "285000"

  const claimNFTs = (_amount) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your Teru Teru NFT...");
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(blockchain.account, _amount)
      .send({
        gasLimit: gasLimit,
        to: "0x827acb09a2dc20e39c9aad7f7190d9bc53534192",
        from: blockchain.account,
        value: blockchain.web3.utils.toWei((price * _amount).toString(), "ether"),
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "WOW, you now own a Teru Teru NFT. go visit Opensea.io to view it."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockchain.account]);

  return (
    <s.Screen style={{ backgroundColor: "var(--black)" }}>
      <s.Container flex={1} ai={"center"}>
        <div></div>

        {/* Navigation */}
        <section class="smart-scroll" style={{ backgroundColor: "#000000" }}>
          <div class="container-fluid">
            <nav class="navbar navbar-expand-md navbar-dark">
              <a
                class="navbar-brand heading-black"
                href="/"
              >
                Teru Teru NFT
              </a>
              <button
                class="navbar-toggler navbar-toggler-right border-0"
                type="button"
                data-toggle="collapse"
                data-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span data-feather="grid"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarCollapse">
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <a class="nav-link page-scroll" href="#about">About</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link page-scroll" href="#minting">Mint</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link page-scroll" href="#roadmap">Roadmap</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link page-scroll" href="#benefit">Benefit</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link page-scroll" href="#charity-program">Charity Program</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link page-scroll" href="#author">Author</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link page-scroll" href="#contact">Contact</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </section>
        {/* about section */}
        <section class="py-7 py-md-0 bg-hero" id="about">
          <div class="container">
            <div class="row vh-md-100">
              <div class="col-md-8 col-sm-10 col-12 mx-auto my-auto text-center">
                <h1 class="heading-black text-capitalize">Lets Control Rain Today!</h1>
                <p class="lead py-3">TeruteruNFT is an NFT project inspired by a Japanese rain repellent doll called teru teru bozu. There are 8,888 unique combinations of TeruteruNFT that you can buy or sell as digital assets. This project stands on a polygon chain and is directly connected to the opensea market, there is a price difference where you get it from public mint sales and from opensea.</p>
                <a class="btn btn-info d-inline-flex flex-row align-items-center" href="#minting">Mint Teru Now!</a>
              </div>
            </div>
          </div>
        </section>
        {/* about section */}
        <section class="py-7 py-md-0 bg-hero" id="roadmap">
          <div class="container">
            <div class="row vh-md-100">
              <div class="col-md-8 col-sm-10 col-12 mx-auto my-auto text-center">
                <h1 class="heading-black text-capitalize">Roadmap</h1>
                <h2 class="heading-black text-capitalize">Roadmap Phase #1</h2>
                <a class="btn btn-warning d-inline-flex flex-row align-items-center" href="#roadmap2">Go to Roadmap Phase #2</a>
              </div>
              <div class="col-md-12 row">
                <div class="col">
                  <h4>1. Community & Social Media</h4>
                  <p class="text-justify">Our concern is to build a community and increase the exposure of this project through social media such as Twitter and Instagram, the goal of this stage is to have <span class="text-success">1k followers and 500 discord members</span>.</p>
                </div>
                <div class="col">
                  <h4>2. Community Event</h4>
                  <p class="text-justify">There will be several <span class="text-success">giveaways</span> and openings for whitelist spots, the purpose of this event is to strengthen relationships within the community.</p>
                </div>
                <div class="col">
                  <h4>3. Pre Sale Event</h4>
                  <p class="text-justify">Community members have the opportunity to take part in the pre sale event which will be held for <span class="text-warning d-flex flex-nowrap">1 week.</span> The price during presale is <span class="text-success">2 Matic</span> per NFT.</p>
                </div>
                <div class="col">
                  <h4>4. Ready to Fly!</h4>
                  <p class="text-justify">Launch the minting website on <span class="text-success font-weight-bold">22nd march 2022</span>, now teru is ready to mint for <span class="text-success">3 Matic</span> each!</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* about section */}
        <section class="py-7 py-md-0 bg-hero" id="roadmap2">
          <div class="container">
            <div class="row vh-md-100">
              <div class="col-md-8 col-sm-10 col-12 mx-auto my-auto text-center">
                <h2 class="heading-black text-capitalize">Roadmap Phase #2</h2>
              </div>
              <div class="col-md-12 row">
                <div class="col">
                  <h4>1. Charity</h4>
                  <p class="text-justify"><span class="text-success">Donate 5%</span> of the profits from sales during pre-sales and public sales to <span class="font-weight-bold">flood victims</span> through licensed organizations, donation reports will be announced to all community members</p>
                </div>
                <div class="col">
                  <h4>2. Collaboration</h4>
                  <p class="text-justify">We are open to collaboration with other NFT artists as well as NFT activists with the aim of expanding reach and increasing brand value.</p>
                </div>
                <div class="col">
                  <h4>3. A Gifts!</h4>
                  <p class="text-justify">Release special version of <b>Teru Teru NFT</b> and will be <b>gifted</b> to our holders.</p>
                </div>
                <div class="col">
                  <h4>4. Let's Write Our Story!</h4>
                  <p class="text-justify">Whatever it is, we hope this project can be successful in the future. The community that has been formed as well as the loyal members are our optimism in developing this project. So we're very open to suggestions and let's write our stories! Make this project <span class="text-warning font-weight-bold">Boom!</span></p>
                </div>
              </div>
            </div>
          </div>
        </section>
          
        <div class="col-md-8 col-sm-10 col-12 mx-auto my-auto text-center">
          <h1 class="heading-black text-capitalize">Let's Mint Now!</h1>
        </div>
        <ResponsiveWrapper flex={1} style={{ padding: 24 }} id="minting">
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg alt={"example"} src={i1} />
            <s.SpacerMedium />
            <s.TextTitle
              style={{ textAlign: "center", fontSize: 35, fontWeight: "bold" }}
            >
              {blockchain.account === "" || blockchain.smartContract === null ? "????" : data.totalSupply}/8888
            </s.TextTitle>
          </s.Container>
          <s.SpacerMedium />
          <s.Container
            flex={1}
            jc={"center"}
            ai={"center"}
            style={{ backgroundColor: "#383838", padding: 24 }}
          >
            {Number(data.totalSupply) === 8888 ? (
              <>
                <s.TextTitle style={{ textAlign: "center" }}>
                  The sale has ended.
                </s.TextTitle>
                <s.SpacerSmall />
                <s.TextDescription style={{ textAlign: "center" }}>
                  You can still find Teru Teru NFT on{" "}
                  <a
                    target={"_blank"}
                    rel={"noreferrer"}
                    href={"https://opensea.io/collection/teruterunft"}
                  >
                    Opensea.io
                  </a>
                </s.TextDescription>
              </>
            ) : (
              <>
                <s.TextTitle style={{ textAlign: "center" }}>
                  1 TTNFT costs <span class="text-success font-weight-bold">{price} MATIC</span>.
                </s.TextTitle>
                <s.TextDescription style={{ textAlign: "center" }}>
                  Excluding gas fee.
                </s.TextDescription>
                <s.TextDescription style={{ textAlign: "center" }}>
                  {feedback}
                </s.TextDescription>
                <s.SpacerMedium />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription style={{ textAlign: "center" }}>
                      Connect to your Polygon network
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      CONNECT
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription style={{ textAlign: "center" }}>
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <s.Container ai={"center"} jc={"center"}>
                    <StyledInput
                      value={input}
                      type="number"
                      onInput={e => setInput(e.target.value)}
                      min="1"
                      max="50"
                    >
                    </StyledInput>
                    <s.SpacerSmall />
                    <StyledButton
                      disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        claimNFTs(input);
                        getData();
                      }}
                    >
                      {claimingNft ? "BUSY" : "BUY"}
                    </StyledButton>
                  </s.Container>
                )}
              </>
            )}
          </s.Container>
        </ResponsiveWrapper>
        <s.SpacerSmall />
        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          <s.TextDescription style={{ textAlign: "center", fontSize: 9 }}>
            Please make sure you are connected to the right network (Polygon
            Mainnet) and the correct address. Please note: Once you make the
            purchase, you cannot undo this action.
          </s.TextDescription>
          <s.SpacerSmall />
          <s.TextDescription style={{ textAlign: "center", fontSize: 9 }}>
            We have set the gas limit to {gasLimit} for the contract to successfully
            mint your NFT. We recommend that you don't change the gas limit.
          </s.TextDescription>
        </s.Container>
      </s.Container>
    </s.Screen>
  );
}

export default App;
